import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type DialogueModalProps = {
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  isOpen: boolean;
  title: string;
  handleClose: (e?: any) => void;
  isShowCloseButton?: boolean;
  children?: React.ReactNode;
  dialogContentProps?: React.ComponentProps<typeof DialogContent>;
  className?: string;
  titleSx?: Record<string, any>;
  headerContent?: React.ReactNode;
  PaperProps?: Record<string, any>;
}

const DialogueModal: React.FC<DialogueModalProps> = ({
  isOpen,
  title,
  handleClose,
  isShowCloseButton = true,
  width,
  children,
  dialogContentProps,
  className,
  titleSx,
  headerContent,
  PaperProps
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth={width || "sm"}
      className={className}
      PaperProps={PaperProps}
      sx={{
        margin: '0 30px 0 25px'
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: 'primary.main',
          color: 'white.main',
          p: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...titleSx,
        }}
      >
        <Box>
          <Typography variant='widgetTitle'>{title}</Typography>
          {headerContent}
        </Box>

        {isShowCloseButton && (
          <IconButton
            onClick={handleClose}
            sx={{
              color: 'white.main',
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ textAlign: 'center' }} {...dialogContentProps}>
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogueModal;